import React, { useContext, useState, useEffect, useRef } from 'react'
import { Button } from '@mui/material'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import AlertContext from '@/product/context/alert/alertContext'
import Loaders from '@/product/components/molecules/Loaders'
import AuthContext from '@/product/context/auth/authContext'
import NotesContext from '@/product/context/notes/notesContext'
import { dateTimeFormatFunction } from '@/custom/common/components'
import CustomDialog from '@/product/components/organisms/Dialog'
import NotesCustomTable from '@/custom/components/organisms/NotesCustomTable'

const UserNotes = (props) => {
    const alertContext = useContext(AlertContext)
    const authContext = useContext(AuthContext)
    const notesContext = useContext(NotesContext)
    const {
        all_notes,
        responseStatus,
        getAllNotes,
        notesManage,
        clearResponse,
    } = notesContext
    const { setAlert } = alertContext
    const { user } = authContext

    const [isLoading, setIsLoading] = useState(true)

    const [tableBody, setTableBody] = useState([])
    const [addNotesStatus, setAddNotesStatus] = useState(false)

    const handleAddNotesStatus = () => {
        setAddNotesStatus(!addNotesStatus)
        formikNote.handleReset()
    }

    const formikNote = useFormik({
        initialValues: {
            project_id: 0,
            user_id: user?.admin_id,
            notes: '',
            active: 1,
            action: 'addComment',
            uploadimages: '',
        },
        validationSchema: Yup.object({
            notes: Yup.string().required('Required!'),
        }),
        onSubmit: (values) => {
            values.project_id = props?.projectId
            values.action = 'addComment'
            if (user?.admin_id) {
                values.user_id = user?.admin_id ? user?.admin_id : 0
                values.username = user?.username
                    ? user?.username
                    : user?.emp_firstname + '' + user?.emp_lastname

                notesManage(values, 'addNotesView')
            }
        },
    })

    const addNotesField = {
        formik: formikNote,
        data: [
            {
                label: 'Notes *',
                name: 'notes',
                type: 'textarea',
                class: 'col-12',
                placeholder: 'Enter notes',
                autoFocus: true,
                rows: 4,
            },
            {
                type: 'uploadDropZone',
                name: 'uploadimages',
                titleText: 'Upload product images',
                innerText: 'Recommended dimensions: 500px * 500px',
                class: 'col-12',
                folder: 'product',
                multiple: false,
                accept: 'image/*',
            },
        ],
    }

    useEffect(() => {
        if (responseStatus && responseStatus?.from === 'addNotesView') {
            formikNote.values.action = ''
            formikNote.values.notes = ''
            setAlert('Notes Added Successfully', 'success')
            setIsLoading(true)
            let initialfilter = {
                project_id: props.projectId,
                from: 'productComment',
                action: 'getSellerNotes',
                user_id: props?.sellerId,
            }
            setIsLoading(true)

            getAllNotes(initialfilter)
            handleAddNotesStatus()
            clearResponse()
        }
    }, [responseStatus])

    useEffect(() => {
        if (props?.projectId) {
            let initialfilter = {
                project_id: props.projectId,
                from: 'productComment',
                action: 'getSellerNotes',
                user_id: props?.sellerId,
            }
            setIsLoading(true)

            getAllNotes(initialfilter)
        }
    }, [props.projectId])

    useEffect(() => {
        if (all_notes?.all_records?.length > 0) {
            setTableBody(all_notes?.all_records)
            setIsLoading(false)
        } else {
            setTableBody([])
            setIsLoading(false)
        }
    }, [all_notes])
    const columns = [
        {
            header: 'Username',
            accessor: 'username',
            minWidth: '150px',
        },
        {
            header: 'Notes',
            accessor: 'notes',
            width: '460px',
            minWidth: '300px',
        },
        {
            header: 'Image',
            accessor: 'uploadimages',
            minWidth: '120px',
            render: (data) =>
                data?.uploadimages ? (
                    <img
                        src={global.images_url + data.uploadimages}
                        alt={data.username}
                        style={{
                            height: '110px',
                            width: '120px',
                            objectFit: 'cover',
                            borderRadius: '6px',
                        }}
                    />
                ) : (
                    '-'
                ),
        },
        {
            header: 'Date',
            accessor: 'date',
            minWidth: '200px',
            render: (data) => dateTimeFormatFunction(data?.date),
        },
    ]
    return (
        <>
            <div className="dashboard staticPages">
                <div className="cmtPgWrpr mt-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <PrimaryButton
                            id="userManage_dynamic_add"
                            label={'Add Notes'}
                            onClick={() => setAddNotesStatus(true)}
                        />
                    </div>

                    {isLoading ? (
                        <div className="fspLoader mt-3">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <NotesCustomTable columns={columns} data={tableBody} />
                    )}
                </div>
            </div>

            <CustomDialog
                title={'Add Notes'}
                open={addNotesStatus}
                function={handleAddNotesStatus}
            >
                <div className="row">{mapData(addNotesField)}</div>

                <div className="actionWrapper">
                    <Button
                        id="auction_cancel"
                        onClick={() => handleAddNotesStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikNote.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="auction_table_submit"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </>
    )
}
export default UserNotes
